import { ShortMessage } from "./short_message";

export class ShortMessages extends Array<ShortMessage> {
  constructor(integrations?: ShortMessage[]) {
    super();
    if (integrations instanceof Array) {
      integrations.forEach((integration) => this.push(integration));
    }
  }
}
